'use strict';

import { isUndefined } from "util";
import { forIn } from 'lodash';

export var workflowService = function (configService, $http, $state, $window) {


    var getOrCreateTicket = function (listId, studyId, entryParameters) {

        return configService.getAppSettings().then(settings => {
            return $http({
                url: `${settings.apiUrl}ticket/getOrCreate/${listId}/${studyId}`,
                method: 'GET',
                params: entryParameters
            }).then(res => {
                return res.data;
            }).catch(ex => {
                $state.go('error', { myErrorMessage: ex.data.error });
            });
        });
    };

    var getTicket = function (ticketId) {
        return configService.getAppSettings().then(settings => {
            return $http({
                url: `${settings.apiUrl}ticket/${ticketId}`,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                },
            }).then(res => {
                return res.data;
            });
        });
    };

    var transition = function (ticketId, currentStep) {
        return configService.getAppSettings().then(settings => {

            var url = `${settings.apiUrl}step/transition/${ticketId}`;

            return $http({
                url: url,
                method: 'POST',
                headers: {
                    'TicketId': ticketId
                },
                data: isUndefined(currentStep) ? null : currentStep
            }).then(res => {
                var executionStep = res.data;

                if (executionStep) {
                    $state.go(executionStep.studyStep.route, {
                        executionStep: executionStep,
                        ticketId: executionStep.ticketStep.ticketId,
                        stepId: executionStep.ticketStep.stepId
                    });
                } else {
                    $state.go('ticketCompleted', {
                        ticketId: ticketId
                    });
                }
            }).catch(ex => {
                $state.go('error', { myErrorMessage: ex.data.error });
            });
        });
    };

    var initializeStep = function (ticketId, stepId) {
        return configService.getAppSettings().then(settings => {

            var url = `${settings.apiUrl}step/initialize/${ticketId}/${stepId}`;

            return $http({
                url: url,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then(res => {
                var executionStep = res.data;

                if (executionStep) {
                    if (executionStep.studyStep.route !== 'stepCompleted') return executionStep;

                    $state.go('stepCompleted', {
                        executionStep: executionStep
                    });
                }

                $state.go('ticketCompleted', {
                    ticketId: ticketId
                });
            }).catch(ex => {
                $state.go('error', { myErrorMessage: ex.data.error });
            });
        });
    };

    var getTicketStep = function (ticketId, stepId) {

        return configService.getAppSettings().then(settings => {
            var url = `${settings.apiUrl}step/${ticketId}/${stepId}`;

            return $http({
                url: url,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then(res => {
                return res.data;
            }).catch(ex => {
                $state.go('error', { myErrorMessage: ex.data.error });
            });
        });
    };

    var getTicketStepWithTicketStepID = function (ticketId, ticketStepId) {

        return configService.getAppSettings().then(settings => {
            var url = `${settings.apiUrl}step/${ticketStepId}`;

            return $http({
                url: url,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then(res => {
                return res.data;
            }).catch(ex => {
                $state.go('error', { myErrorMessage: ex.data.error });
            });
        });
    };

    var goToFirstActiveStep = function (ticketId) {
        return configService.getAppSettings().then(settings => {
            var url = `${settings.apiUrl}step/firstActive/${ticketId}`;

            return $http({
                url: url,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then(res => {
                var executionStep = res.data;

                if (executionStep) {
                    $state.go(executionStep.studyStep.route, {
                        executionStep: executionStep,
                        ticketId: executionStep.ticketStep.ticketId,
                        stepId: executionStep.studyStep.id
                    });
                } else {
                    $state.go('ticketCompleted', {
                        ticketId: ticketId
                    });
                }
            }).catch(ex => {
                $state.go('error', { myErrorMessage: ex.data.error });
            });
        });
    };

    function _completeTicket_(apiUrl, ticketId, status) {
        var url = `${apiUrl}ticket/${ticketId}/complete`;
        if (status) url = url + `/${status}`;

        return $http({
            url: url,
            method: 'POST',
            headers: {
                'TicketId': ticketId
            }
        });
    }

    function _getTicket_(apiUrl, ticketId) {
        var url = `${apiUrl}ticket/${ticketId}`;

        return $http({
            url: url,
            method: 'GET',
            headers: {
                'TicketId': ticketId
            }
        }).then(res => {
            return res.data;
        });
    }

    function _canIncludeInPanelRedirect(key) {
        //common parts of ticket parameters we do not want to include
        var exclude = ['appmode', 'appversion', 'purchased', 'max', 'min', 'flyin', 'sdtinstructions', 'external'];
        for (var i = 0; i < exclude.length; i++) {
            var keyword = exclude[i];
            if (key.toLowerCase().includes(keyword)) return false;
        }
        return true;
    }

    function _completeTicketStep(apiUrl, ticketStepId) {
        var url = `${apiUrl}step/${ticketStepId}/complete`;

        return $http({
            url: url,
            method: 'POST',
            headers: {
                'TicketStepId': ticketStepId
            }
        })
    }

    var completeTicketWithoutRedirect = function (ticketStep) {
        var ticketId = ticketStep.ticketId;
        var ticketStepId = ticketStep.id;
        return configService.getAppSettings().then(settings => {
            return _completeTicketStep(settings.apiUrl, ticketStepId).then(() => {
                return _getTicket_(settings.apiUrl, ticketId).then(ticket => {
                    return _completeTicket_(settings.apiUrl, ticketId, 'complete').then(() => {
                        return ticket;
                    });
                });
            });
        });
    };


    var completeTicket = function (ticketId, status) {

        return configService.getAppSettings().then(settings => {
            _getTicket_(settings.apiUrl, ticketId).then(ticket => {
                _completeTicket_(settings.apiUrl, ticketId, status).then(() => {

                    var url = ticket.panel.completeLink;
                    status = status || '';

                    switch (status.toLowerCase()) {
                        case 'overquota':
                            url = ticket.panel.overquotaLink;
                            break;
                        case 'terminate':
                            url = ticket.panel.terminateLink;
                            break;
                    }

                    // If no URL is defined, don't attempt to redirect
                    if (!url) {
                        return;
                    }

                    // Parse existing URL to handle existing parameters
                    var urlParts = url.split('?');
                    var baseUrl = urlParts[0];
                    var existingParams = {};

                    if (urlParts.length > 1) {
                        // Parse existing query string parameters
                        urlParts[1].split('&').forEach(function (param) {
                            var parts = param.split('=');
                            if (parts.length > 0) {
                                var key = decodeURIComponent(parts[0]);
                                existingParams[key.toLowerCase()] = parts.length > 1 ? decodeURIComponent(parts[1]) : '';
                            }
                        });
                    }

                    // Add or update parameters from ticket
                    forIn(ticket.parameters, function (value, key) {
                        if (_canIncludeInPanelRedirect(key)) {
                            existingParams[key.toLowerCase()] = value;
                        }
                    });

                    // Rebuild URL with all parameters
                    var paramString = '';
                    var first = true;
                    forIn(existingParams, function (value, key) {
                        if (!first) {
                            paramString += '&';
                        }
                        paramString += encodeURIComponent(key) + '=' + encodeURIComponent(value);
                        first = false;
                    });

                    url = baseUrl + (paramString ? '?' + paramString : '');

                    $window.onbeforeunload = null;
                    service.redirect(url);
                });
            });
        });
    };

    var updateTicketStepParameters = function (ticketStepId, parameters) {

        return configService.getAppSettings().then(settings => {
            var url = `${settings.apiUrl}step/updateParameters`;

            return $http({
                url: url,
                method: 'POST',
                headers: {
                    'TicketStepId': ticketStepId
                },
                data: {
                    ticketStepId: ticketStepId,
                    parameters: parameters
                }
            })
        });
    };

    //this only exists for testing (can't mock window.location.assign)
    var redirect = function (url) {
        $window.location.href = url;
    }

    var processExternalEcommercePassback = function (ticketId, ticketStepId, passbackParams) {
        return configService.getAppSettings().then(settings => {
            var url = `${settings.apiUrl}externalEcommerce/processPassback`;

            return $http({
                url: url,
                method: 'POST',
                data: {
                    ticketId: ticketId,
                    ticketStepId: ticketStepId,
                    passbackParams: passbackParams
                }
            });
        });
    };

    var service = {
        completeTicket: completeTicket,
        completeTicketWithoutRedirect: completeTicketWithoutRedirect,
        getOrCreateTicket: getOrCreateTicket,
        getTicket: getTicket,
        getTicketStep: getTicketStep,
        getTicketStepWithTicketStepID: getTicketStepWithTicketStepID,
        goToFirstActiveStep: goToFirstActiveStep,
        initializeStep: initializeStep,
        processExternalEcommercePassback: processExternalEcommercePassback,
        redirect: redirect,
        transition: transition,
        updateTicketStepParameters: updateTicketStepParameters
    };

    return service;
};

workflowService.$inject = ['configService', '$http', '$state', '$window']